import { FiDownload } from 'react-icons/fi';
import SoftButton from './SoftButton';

function DownloadButton({
    ButtonComponent = SoftButton,
    children = 'Export Data',
    mixpanelContext = 'Download CSV',
    IconLeft = FiDownload,
    size = 'sm',
    ...restProps
}) {
    return (
        <ButtonComponent
            children={children}
            mixpanelContext={mixpanelContext}
            IconLeft={IconLeft}
            size={size}
            {...restProps}
        />
    );
}

export default DownloadButton;
